import ModuleSectionV4 from './ModuleSectionV4';
import PageImage from '../../common/component/PageImage';
import {IImageModuleV4} from '../type';

interface IProps {
  data: IImageModuleV4;
}

export default function ImageModuleV4({data}: IProps) {
  const {section, imageList} = data;

  return (
    <ModuleSectionV4
      data-module-type={data.moduleType}
      section={section}
      innerClassName="flex-center flex-col"
    >
      {imageList.map((image, index) => (
        <PageImage
          key={index}
          src={image}
          alt=""
          className="w-full md:max-w-[440px]"
        />
      ))}
    </ModuleSectionV4>
  );
}
